import { render, staticRenderFns } from "./ProfileAvatar.vue?vue&type=template&id=1e7e5f5e&"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts&"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports